import type { Span } from "../../bridge/binary";
import type { ShapeManagerPoint } from "../../bridge/selection";
import { useJsonReader } from "../../bridge/binary";
import { createProxies } from "./proxies";

export interface EditorExports {
  Editor: EditorExportsMethods;
}

export interface Point {
  x: number;
  y: number;
}

export interface GradientInfo {
  center: Point;
  axis1: Point;
  axis2: Point | undefined;
  stops: number[];
}

export enum EditorSetting {
  SnapToGrid = 1,
}

interface EditorExportsMethods {
  GetScrollZoom: () => { x: number; y: number; zoom: number; panelX: number; panelY: number; panelWidth: number; panelHeight: number };
  SetZoom: (val: string) => boolean;
  SetEditPermissions: (canEdit: boolean) => void;
  GetShapeManagerSelectedPoints: () => Span<ShapeManagerPoint[]>;
  GetGradientModeGeometryInfo: () => Span<GradientInfo>;
  SetVectorPointProperty: (property: BezierPointProperty, val: number) => Promise<void>;
  SetClientSettingBool: (key: EditorSetting, val: boolean) => void;
  RenderLoopIdled: () => void;
  EditorVisibleChanged: (visible: boolean) => void;
  DeepSleepChanged: (deepSleep: boolean) => void;
  BeforeUnload: () => void;
}

export enum BezierPointProperty {
  X = 1,
  Y = 2,
  Radius = 3,
}

export const {
  setup,
  getScrollZoom: getScrollZoomProxy,
  setZoom,
  setEditPermissions,
  getShapeManagerSelectedPoints,
  getGradientModeGeometryInfo,
  setVectorPointProperty,
  setClientSettingBool,
  renderLoopIdled,
  editorVisibleChanged,
  deepSleepChanged,
  beforeUnload,
} = createProxies<EditorExportsMethods>([
  "GetScrollZoom",
  "SetZoom",
  "SetEditPermissions",
  "GetShapeManagerSelectedPoints",
  "GetGradientModeGeometryInfo",
  "SetVectorPointProperty",
  "SetClientSettingBool",
  "RenderLoopIdled",
  "EditorVisibleChanged",
  "DeepSleepChanged",
  "BeforeUnload",
]);

export const getScrollZoom = useJsonReader(getScrollZoomProxy);
